export default function Logo({ size = 32, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Cam Control Hub"
      style={{ height: size, width: "auto" }}
      className={`object-contain ${className}`}
    />
  );
}
